import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { useAccount } from 'reservations/account/providers/AccountProvider';
import UnderlinedLink from 'reservations/base/components/UnderlinedLink';
import { WHITE } from 'reservations/brand/constants';

type WaitlistMessageProps = {
  dataTestId: string;
  message: string;
};

const WaitlistMessage = ({ dataTestId, message }: WaitlistMessageProps) => {
  const { connected_location_integrations: connectedLocationIntegrations } =
    useAccount();
  const isMultiLocation = connectedLocationIntegrations.length > 1;

  return (
    <Grid
      container
      direction="column"
      gap="24px"
      alignItems="center"
      justifyContent="center"
      marginTop="70px"
    >
      <Grid item>
        <Typography
          sx={{
            fontSize: '16px',
            textAlign: 'center',
            color: 'white'
          }}
          data-testid={dataTestId}
        >
          {message}
        </Typography>
      </Grid>
      {isMultiLocation && (
        <Grid item>
          <UnderlinedLink
            href="/locations"
            openNewTab={false}
            color={WHITE}
            hoverColor={WHITE}
          >
            Return to Homepage
          </UnderlinedLink>
        </Grid>
      )}
    </Grid>
  );
};

export default WaitlistMessage;
